module.exports = __webpack_public_path__ + "img/self_publisher.12855054.svg";